import React from "react";
import { useTheme } from "@hooks/useTheme";

const CustomRadio = ({ name, value, checked, onChange, label, className = "", size = "md", disabled = false, ...props }) => {
  const { colors } = useTheme();

  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return "w-3 h-3 after:w-1 after:h-1";
      case "lg":
        return "w-6 h-6 after:w-3 after:h-3";
      case "md":
      default:
        return "w-4 h-4 after:w-2 after:h-2";
    }
  };

  const radioClass = `
    ${!disabled ? 'cursor-pointer hover:opacity-80' : ''}
    appearance-none rounded-full border-2
    ${colors.borderRadio} ${colors.bgSecondary}
    ${colors.borderRadioChecked}
    relative transition-colors
    after:content-[''] after:block after:rounded-full
    after:mx-auto after:my-auto ${colors.bgRadioChecked} after:scale-0
    checked:after:scale-100
    after:transition-transform after:duration-150 after:absolute
    after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2
    ${getSizeClasses()}
    ${className}
  `;

  return (
    <label
      className={`flex items-center gap-2 ${!disabled ? 'cursor-pointer' : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={radioClass}
        {...props}
      />
      {label && <span className={`text-sm ${colors.textSecondary}`}>{label}</span>}
    </label>
  );
};

export default CustomRadio; 